import { Component, OnDestroy } from '@angular/core';
import { takeWhile } from 'rxjs/operators';
import { NetworkConnectionService } from './network-connection.service';

@Component({
    selector: 'app-network-connection',
    templateUrl: './network-connection.component.html',
    styleUrls: ['./network-connection.component.scss'],
    standalone: false
})
export class NetworkConnectionComponent implements OnDestroy {

    private alive: boolean = true;
    public description: string;
    public isConnectedClass: string;
    public networkStatus: string;
    public isConnected: boolean = true;

    constructor(
        private networkService: NetworkConnectionService
    ) {
        this.tryConnection();
    }

    tryConnection(): void {
        this.networkService.getMessage()
            .pipe(
                takeWhile(() => this.alive)
            )
            .subscribe(message => {
                this.isConnected = message.isConnected;
                if (!message.isConnected) {
                    this.isConnectedClass = message.isConnectedClass;
                    this.description = message.description;
                    this.networkStatus = 'offline';
                } else {
                    setTimeout(() => {
                        this.isConnectedClass = message.isConnectedClass;
                    }, 3000);
                    this.networkStatus = 'online';
                    this.description = message.description;
                }
            });
    }

    ngOnDestroy(): void {
        this.alive = false;
    }

}
